import React from "react";
import Approuters from "./route";
import {  preloadScript } from "react-speedofme";
import { ToastContainer } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';


function App() {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Approuters />
      <ToastContainer />
    </MuiPickersUtilsProvider>
  );
}

export default preloadScript(App);
